import { useEffect, useState } from 'react';
import Picker from 'react-mobile-picker';
import { PLAYBACK_RATE } from '../constants/local_storage_constants';

// Descending order matches the direction of the speed wheel.
const speedOptions = ['3.0×', '2.9×', '2.8×', '2.7×', '2.6×', '2.5×', '2.4×', '2.3×', '2.2×', '2.1×', '2.0×', '1.9×', '1.8×', '1.7×', '1.6×', '1.5×', '1.4×', '1.3×', '1.2×', '1.1×', '1.0×', '0.9×', '0.8×', '0.7×', '0.6×', '0.5×'];
const presetValues = [1, 1.2, 1.5, 1.8, 2];

const SpeedActions = () => {
    const audio = document.getElementById('audio');

    const [pickerValue, setPickerValue] = useState(() => ({
        speed: audio.playbackRate.toFixed(1) + '×',
    }));

    useEffect(() => {
        const val = parseFloat(pickerValue.speed);
        audio.playbackRate = val;
        localStorage.setItem(PLAYBACK_RATE, val);
    }, [audio, pickerValue]);

    const onPresetClick = (val) => () => {
        setPickerValue({
            speed: val.toFixed(1) + '×',
        });
    };

    return (
        <div>
            <Picker value={pickerValue} onChange={setPickerValue} wheelMode="natural">
                <Picker.Column name='speed'>
                    {speedOptions.map(option => (
                        <Picker.Item key={option} value={option}>
                            {({ selected }) => (
                                <div className={selected ? 'speed-selected' : 'speed-unselected'}>{option}</div>
                            )}
                        </Picker.Item>
                    ))}
                </Picker.Column>
            </Picker>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', margin: '8px 16px 16px' }}>
                {presetValues.map((val) => (
                    <button
                        key={val}
                        onClick={onPresetClick(val)}
                        style={{
                            width: '100%',
                            padding: '8px 0px',
                            fontSize: '13px',
                            color: 'var(--app-text-secondary)',
                            borderRadius: '30px',
                            backgroundColor: 'var(--app-surface)',
                        }}
                    >
                        {val}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SpeedActions;

